'use strict';

import React, { Component } from 'react';
import Moment from "moment";
import Currency from '../../../commonModules/Currency';
import Receipt from '../ClientPrint/Receipt';
import SupressPayment from '../ClientPrint/SupressPayment';
import { TableLayout } from '../Stock/containers/Layout';
import { TableHead, TableBody, TableRow, TableCell, Button, IconButton, TableFooter } from '@material-ui/core';
import { MiniCard } from '../../../commonModules/layouts/CardPage';
import { MonetizationOnRounded, RefreshRounded,DeleteOutlineRounded, DeleteForeverRounded } from '@material-ui/icons';
import { red } from '@material-ui/core/colors';
import { toast } from 'react-toastify';

var $ = require('jquery');

class PaymentList extends Component{
    tabledata = []
        state = {
            //Information
            totalPayed: '',
            totalToPay: '',
            lastPaymentDate: '',
            lastPaymentAmount: '',
            nextPaymentDate: '',
            nextPaymentAmount: '',
            paygoPaymentList: this.tabledata,
            deletePayment: false,
            deletePaymentInfo: {},
            receipt: false,
            paymentInfo: {},
            limit: 5,
        }
    componentDidMount= async () => {
        var methodName = 'Get Payment List';
        var url_money_resume = "/money/resume?boxAssoId=" + this.props.boxAssoId;
        // if(!this.props.boxId){
        //     url_money_resume = "money/resume?userId=" + this.props.userID;

        // }

        this.serverRequest = $.get(url_money_resume, function(result) {
            console.log('[INFO], ', methodName);
            console.log(result);
            var totalPayed = '';
            var totalToPay = '';
            var lastPaymentDate= '';
            var lastPaymentAmount= '';
            var nextPaymentDate = '';
            var nextPaymentAmount= '';
            try {
                var data = result; //var data = JSON.parse(result);
                totalPayed = data.totalPayed;
                totalToPay = data.totalToPay;
                lastPaymentDate = data.lastPaymentDate;
                lastPaymentAmount = data.lastPaymentAmount;
                nextPaymentDate = data.nextPaymentDate;
                nextPaymentAmount = data.nextPaymentAmount;

            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({
                totalPayed: totalPayed,
                totalToPay: totalToPay,
                lastPaymentDate: lastPaymentDate,
                lastPaymentAmount: lastPaymentAmount,
                nextPaymentDate: nextPaymentDate,
                nextPaymentAmount: nextPaymentAmount,
            });
        }.bind(this));
        //Request For payment List
        var methodName2 = 'getLastPayment';
        var url_payment_list = "/box/payment/getlist?boxAssoId=" + this.props.boxAssoId;
        // if(!this.props.boxId){
        //     url_payment_list = "/box/payment/getlist?userId=" + this.props.userID;
        // }

        this.serverRequest2 = $.get(url_payment_list, function(result) {
            console.log('[INFO],  reception des données  du PAYGO ');
            console.log(result);
            var paymentTmp = [];

            try {
                var data = result;

                for (var i = 0; i < data.content.length; i += 1) {

                    var d = Date.parse(data.content[i].timePayment);

                    var dnow = new Date();
                    var offSet = dnow.getTimezoneOffset();
                    var dtz = new Date(d - 1000 * 60 * offSet);

                    paymentTmp.push({
                        Status: data.content[i].status,
                        id: data.content[i].id,
                        timePayment: dtz.toISOString(),
                        money: data.content[i].money,
                        typePayment: data.content[i].typePayment,
                        codeId: data.content[i].codeId,
                        info: data.content[i].info
                    })
                }
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName2, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }

            paymentTmp.sort( (a, b) => {
                a = new Date(a.timePayment);
                b = new Date(b.timePayment);
                if (a > b){
                    return -1;
                }
                if (a < b){
                    return 1;
                }
                return 0;
            })

            this.setState({paygoPaymentList: paymentTmp});
        }.bind(this));
    }
    FormatDate(val){
        return Moment(val).format('DD-MM-YYYY HH:mm');
    }
    deletePayment = (paymentInfo) =>{
        console.log("[UPDATE], deletePayment, ",paymentInfo)
        this.setState({deletePayment: true,deletePaymentInfo:paymentInfo});
    }
    updatePayment = () => {
        console.log("[UPDATE], Payment, ")
        var url = "/payment/list/update";
        fetch(url,{
            method:'PUT',
            headers: {
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
            },
            body: JSON.stringify({
                userID: this.props.userInfo.userID,
                boxID:  this.props.userInfo.boxId,
                boxAssoId:  this.props.boxAssoId,
            }),
            credentials: 'same-origin',
        }).then(info =>{
            console.log("[SUCESS], Payment, ",info)
            toast.success("Upload is ok Code  ",info)
        }).catch(err =>{
                console.log("[ERROR], Payment, ",err)
                toast.error("Payment sync failed, ",err)
            })
    }
    render() {
        const { paygoPaymentList, limit } = this.state;
        console.log(paygoPaymentList);
        
        return (
            <MiniCard
                title="Liste des paiements"
                avatar={<MonetizationOnRounded />}
                action={
                    <IconButton onClick={this.updatePayment} color="secondary">
                        <RefreshRounded />
                    </IconButton>
                }
            >
                {this.state.receipt &&
                    <Receipt 
                        payment={this.state.paymentInfo} 
                        userInfo={this.props.userInfo }
                        close={() => this.setState({receipt: false, paymentInfo: {} })} 
                    />
                }
                {this.state.deletePayment &&
                    <SupressPayment 
                        deletePaymentInfo={this.state.deletePaymentInfo} 
                        close={() => this.setState({deletePayment: false, deletePaymentInfo: {} })} 
                    />
                }
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Montant</TableCell>
                            <TableCell>Mode Réglement</TableCell>
                            <TableCell>Code</TableCell>
                            <TableCell>Ref Paiement</TableCell>
                            <TableCell>Extra Info</TableCell>
                            <TableCell>Reçu</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {paygoPaymentList.slice(0, limit).map( paymentInfo => (
                        // if (){
                        //     return(
                        //         <TableRow hover style={{color: '#fff', background: "red",}}>
                        //             <TableCell>{this.FormatDate(paymentInfo.timePayment)}</TableCell>
                        //             <TableCell><Currency value={paymentInfo.money} suffix=" " /> </TableCell>
                        //             <TableCell>{paymentInfo.typePayment}</TableCell>
                        //             <TableCell>{paymentInfo.codeId}</TableCell>
                        //             <TableCell>{paymentInfo.id}</TableCell>
                        //             <TableCell>{paymentInfo.info}</TableCell>
                        //         </TableRow> 
                        //     )
                        // }
                        //color: #fff; background: red;
                        <TableRow hover style={{
                            background: paymentInfo.Status === "cancel" ? red[100] : "initial"
                        }}>
                            <TableCell>{this.FormatDate(paymentInfo.timePayment)}</TableCell>
                            <TableCell><Currency value={paymentInfo.money} suffix=" " /> </TableCell>
                            <TableCell>{paymentInfo.typePayment}</TableCell>
                            <TableCell>{paymentInfo.codeId}</TableCell>
                            <TableCell>{paymentInfo.id}</TableCell>
                            <TableCell>{paymentInfo.info}</TableCell>
                            <TableCell>
                                {paymentInfo.typePayment !== "gift" && paymentInfo.Status !== "cancel" && 
                                    <Button 
                                        color="primary" 
                                        onClick={() => this.setState({receipt: true, paymentInfo})}
                                    >
                                        Reçu
                                    </Button>
                                }
                            </TableCell>
                            <TableCell>
                                {paymentInfo.Status !== "cancel" && 
                                    <IconButton onClick={()=> this.deletePayment(paymentInfo)} color="secondary">
                                        <DeleteForeverRounded />
                                    </IconButton>
                                }
                            </TableCell>
                        </TableRow>
                        ) )
                    }
                    </TableBody>
                    { paygoPaymentList.length > 5 &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={7} >
                                    {limit === 5 ?
                                        <Button color="secondary" onClick={ () => this.setState({ limit: paygoPaymentList.length })} >Voir Tout</Button>
                                        :
                                        <Button color="secondary" onClick={ () => this.setState({ limit: 5 })} >Voir Moins</Button>
                                    }
                                </TableCell> 
                            </TableRow>
                        </TableFooter>
                    }
                </TableLayout>
            </MiniCard>
        )
    }
};
export default PaymentList
